// // JavaScript code to create and append bird elements
// const birdContainer = document.querySelector('.animation-container');
// const birds = document.querySelectorAll('.bird, .birdtwo, .birdthree');
//
// function createBird() {
//     for (const bird of birds) {
//         bird.style.left = '-100px'; // Start position off-screen
//     }
//     birdContainer.style.opacity = '0.5';
// }
//
// // Create multiple birds
// for (let i = 0; i < 5; i++) {
//     createBird();
// }
//
// birdContainer.style.display = 'flex'; // Make birds fully visible on scroll
//
//
//
// // var timer = null;
// // window.addEventListener('scroll', function() {
// //     if(timer !== null) {
// //         clearTimeout(timer);
// //     }
// //     timer = setTimeout(function() {
// //      birdContainer.style.display = 'none'; // Make birds fully visible on scroll
// //     }, 150);
// // }, false);
//
// // Add scroll and hover event listeners
// document.addEventListener('scroll', () => {
//     birdContainer.style.display = 'flex'; // Make birds fully visible on scroll
// });
//
// birdContainer.addEventListener('mouseover', () => {
//     birdContainer.style.opacity = '0.5'; // Make birds semi-visible on hover
// });
//
// birdContainer.addEventListener('mouseout', () => {
//     birdContainer.style.display = 'flex'; // Restore full visibility on mouseout
// });
